import React from 'react';
import { Alert } from '../../components/ui-kit';

// This component shows an error block with all 'base' errors. These are errors
// that don't relate to a specific field, but rather to the object itself.
const BaseValidationErrorsMessage = props => {
  const validationErrors = props.validationErrors || {};
  const baseErrors = validationErrors.base || [];

  if (baseErrors.length === 0) return null;

  return (
    <Alert variant="danger">
      {baseErrors.map(error => (
        <p key={error}>{error}</p>
      ))}
    </Alert>
  );
};

export default BaseValidationErrorsMessage;
